

export const devChains = [
  { 
    name: 'Ethereum Sepolia', 
    chainId: 11155111, 
    rpcUrl: 'https://sepolia.infura.io/v3/adaf902a3536415c8bba1581f86bad87',
    icon: '/assets/images/ethereum.svg'
  },
  { 
    name: 'BSC Testnet', 
    chainId: 97, 
    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
    icon: '/assets/images/bnb.svg'
  },
  { 
    name: 'Polygon Testnet', 
    chainId: 80001, 
    rpcUrl: 'https://matic-mumbai.chainstacklabs.com',
    icon: '/assets/images/polygon.svg'
  },
  { 
    name: 'Avalanche Testnet', 
    chainId: 43113, 
    rpcUrl: 'https://api.avax-test.network/ext/bc/C/rpc',
    icon: '/assets/images/avax_avax.svg'
  }
]

export const prodChains = [
  { 
    name: 'Ethereum Mainnet', 
    chainId: 1, 
    rpcUrl: 'https://mainnet.infura.io/v3/adaf902a3536415c8bba1581f86bad87',
    icon: '/assets/images/ethereum.svg'
  },
  { 
    name: 'Binance Smart Chain', 
    chainId: 56, 
    rpcUrl: 'https://bsc-dataseed.binance.org/',
    icon: '/assets/images/bnb.svg'
  },
  { 
    name: 'Polygon', 
    chainId: 137, 
    rpcUrl: 'https://polygon-rpc.com/',
    icon: '/assets/images/polygon.svg'
  },
  { 
    name: 'Avalanche', 
    chainId: 43114, 
    rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
    icon: '/assets/images/avax_avax.svg'
  }
]

export const chainIdToName: Record<number, string> = {
    1: 'Ethereum Mainnet',
    56: 'Binance Smart Chain',
    137: 'Polygon (Matic)',
    43114: 'Avalanche C-Chain',
    //  Test
    11155111: 'Ethereum Sepolia Testnet',
    97: 'Binance Smart Chain Testnet',
    80001: 'Polygon Mumbai Testnet',
    43113: 'Avalanche Fuji Testnet'
};



export const chainIdToImage: Record<number, string> = {
    1: '/assets/images/ethereum.svg',
    56: '/assets/images/bnb.svg',
    137: '/assets/images/polygon.svg',
    43114: '/assets/images/avax_avax.svg',
    // Test
    11155111: '/assets/images/ethereum.svg',
    97: '/assets/images/bnb.svg',
    80001: '/assets/images/polygon.svg',
    43113: '/assets/images/avax_avax.svg'
}

export function generateTransactionLink(transactionHash: string, chainId: number): string | null {
    const explorers: { [key: number]: string } = {
      1: 'https://etherscan.io/tx/',       // Ethereum Mainnet
      56: 'https://bscscan.com/tx/',       // Binance Smart Chain
      137: 'https://polygonscan.com/tx/',  // Polygon
      43114: 'https://snowtrace.io/tx/',   // Avalanche
      11155111: 'https://sepolia.etherscan.io/tx/', // Ethereum Sepolia
      97: 'https://testnet.bscscan.com/tx/',       // BSC Testnet
      80001: 'https://mumbai.polygonscan.com/tx/', // Polygon Testnet
      43113: 'https://testnet.snowtrace.io/tx/'    // Avalanche Testnet
    };
    
    console.log(`${explorers[chainId]}${transactionHash}`);
  
    if (explorers[chainId]) {
      return `${explorers[chainId]}${transactionHash}`;
    }
    
    console.error(`No explorer found for chainId: ${chainId}`);
    return null;
  }